(function () {
  "use strict";

  if (window.PdpProductState) return;

  var CHANGE_EVENT = "pdp:variant-change";

  function getStateElement() {
    return document.querySelector("[data-pdp-product-state]");
  }

  function readState() {
    var el = getStateElement();
    if (!el) return null;
    if (!el.__pdpStateCache) {
      try {
        el.__pdpStateCache = JSON.parse(el.textContent);
      } catch (e) {
        el.__pdpStateCache = null;
      }
    }
    return el.__pdpStateCache;
  }

  function getVariantId() {
    var input =
      document.querySelector('product-form input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!input || !input.value) return null;
    var parsed = parseInt(input.value, 10);
    return isNaN(parsed) ? null : parsed;
  }

  function getCurrentVariant() {
    var state = readState();
    if (!state || !Array.isArray(state.variants)) return null;
    var variantId = getVariantId();
    var fallbackId = state.selectedVariantId || null;
    var activeId = variantId || fallbackId;

    for (var i = 0; i < state.variants.length; i++) {
      if (state.variants[i].id === activeId) return state.variants[i];
    }

    return state.variants[0] || null;
  }

  function parseDate(value) {
    if (!value) return null;
    var parsed = new Date(value + "T23:59:59");
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  function isFutureDate(value) {
    var date = parseDate(value);
    if (!date) return false;

    var today = new Date();
    today.setHours(0, 0, 0, 0);
    return date.getTime() > today.getTime();
  }

  function isPreorderVariant(variant) {
    if (!variant) return false;
    if (variant.available === false) return false;
    return isFutureDate(variant.restockDate);
  }

  function formatMonthYear(value) {
    var date = parseDate(value);
    if (!date) return "";

    return new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(date);
  }

  function getAddToCartLabel(variant) {
    if (!variant) return "Add to cart";
    if (variant.available === false) return "Sold out";
    if (isPreorderVariant(variant)) return "Pre-order Now";
    return "Add to cart";
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function normalizeConstructionKey(value) {
    var normalized = String(value || "")
      .trim()
      .toLowerCase();

    switch (normalized) {
      case "pu":
      case "pu series":
      case "poly":
      case "polyester":
      case "pu construction":
        return "pu";
      case "truelite":
      case "true lite":
      case "truelite construction":
        return "truelite";
      case "dark phantom":
      case "dark phantom construction":
        return "darkphantom";
      default:
        return normalized.replace(/[\s-]+/g, "");
    }
  }

  function getConstructionConfig(variant, state) {
    if (!variant || !state || !state.constructionAssets) return null;
    return state.constructionAssets[normalizeConstructionKey(variant.construction)] || null;
  }

  function buildTrustItem(icon, text) {
    return {
      icon: icon,
      text: text,
    };
  }

  function getTrustMessages(state, variant) {
    if (!state || !variant) return [];

    var isOversized = state.isOversizedProduct === true;
    var isSpecialOrder = state.isSpecialOrderProduct === true;
    var isPreorder = isPreorderVariant(variant);

    if (isOversized || isSpecialOrder) {
      return [
        buildTrustItem(
          "warning",
          "Oversized items are excluded from free shipping.",
        ),
        buildTrustItem(
          "pickup",
          "Free in-store pickup available in Wildwood, NJ.",
        ),
        buildTrustItem(
          "policy",
          "Freight rates or return exceptions may apply to boards and special-order items.",
        ),
      ];
    }

    if (isPreorder) {
      return [
        buildTrustItem(
          "calendar",
          "Pre-order items ship after the expected arrival window.",
        ),
        buildTrustItem(
          "shipping",
          "Free shipping on orders $75+ (excluding oversized items).",
        ),
        buildTrustItem("returns", "60-day returns on unused items."),
      ];
    }

    return [
      buildTrustItem(
        "shipping",
        "Free shipping on orders $75+ (excluding oversized items).",
      ),
      buildTrustItem(
        "pickup",
        "Free in-store pickup available in Wildwood, NJ.",
      ),
      buildTrustItem("returns", "60-day returns on unused items."),
    ];
  }

  function getTrustIconSvg(icon) {
    switch (icon) {
      case "shipping":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M3 7.5h11v8H3z" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M14 10h3.4l2.6 2.7v2.8H14z" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="8" cy="18" r="1.7" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="17" cy="18" r="1.7" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
      case "pickup":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 21s5-4.35 5-9a5 5 0 1 0-10 0c0 4.65 5 9 5 9Z" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="12" r="1.9" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
      case "returns":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 7H5v4" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M5.5 10.5A6.5 6.5 0 0 1 17 8.5" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M15 17h4v-4" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M18.5 13.5A6.5 6.5 0 0 1 7 15.5" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
      case "calendar":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="6" width="16" height="14" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M8 4.5v3M16 4.5v3M4 10h16" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M8.5 13h3" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
      case "warning":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4 20 19H4z" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M12 9v4.5" fill="none" stroke="currentColor" stroke-width="1.7"/><circle cx="12" cy="16.5" r=".8" fill="currentColor"/></svg>';
      case "policy":
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 4.5h7l4 4V19a1.5 1.5 0 0 1-1.5 1.5H8A1.5 1.5 0 0 1 6.5 19V6A1.5 1.5 0 0 1 8 4.5Z" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M15 4.5V9h4" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M9 12h6M9 15h6" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
      default:
        return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="5" fill="none" stroke="currentColor" stroke-width="1.7"/></svg>';
    }
  }

  function renderTrustItem(item) {
    return (
      '<li class="trust-messages__item">' +
      '<span class="trust-messages__item-icon" aria-hidden="true">' +
      getTrustIconSvg(item.icon) +
      "</span>" +
      '<span class="trust-messages__item-text">' +
      escapeHtml(item.text) +
      "</span>" +
      "</li>"
    );
  }

  function normalizeColor(value) {
    return String(value || "")
      .replace(/\s+/g, "")
      .toLowerCase();
  }

  function syncProductWizSwatchSelection() {
    var swatches = document.querySelectorAll(
      '[class*="rio-swatch-border-double"]',
    );
    var selectedColor = normalizeColor("rgb(0, 220, 255)");
    var foundSelected = false;

    if (!swatches.length) return false;

    for (var i = 0; i < swatches.length; i++) {
      var swatch = swatches[i];
      var swatchButton = swatch.closest('[class*="PwzrButton-root"]');
      var style = window.getComputedStyle(swatch);
      var borderColors = [
        normalizeColor(style.borderTopColor),
        normalizeColor(style.borderRightColor),
        normalizeColor(style.borderBottomColor),
        normalizeColor(style.borderLeftColor),
        normalizeColor(swatch.style.borderTopColor),
        normalizeColor(swatch.style.borderRightColor),
        normalizeColor(swatch.style.borderBottomColor),
        normalizeColor(swatch.style.borderLeftColor),
      ];
      var isSelected = borderColors.indexOf(selectedColor) !== -1;

      if (isSelected) {
        swatch.setAttribute("data-pdp-selected", "true");
        if (swatchButton)
          swatchButton.setAttribute("data-pdp-selected", "true");
        foundSelected = true;
      } else {
        swatch.removeAttribute("data-pdp-selected");
        if (swatchButton) swatchButton.removeAttribute("data-pdp-selected");
      }
    }

    return foundSelected;
  }

  function scheduleSwatchSync(attempt) {
    var count = typeof attempt === "number" ? attempt : 0;

    window.requestAnimationFrame(function () {
      var foundSelected = syncProductWizSwatchSelection();

      if (!foundSelected && count < 5) {
        window.setTimeout(function () {
          scheduleSwatchSync(count + 1);
        }, 60);
      }
    });
  }

  function renderPreorder() {
    var root = document.querySelector("[data-pdp-preorder-root]");
    var variant = getCurrentVariant();
    if (!root || !variant) return;

    if (!isPreorderVariant(variant)) {
      root.hidden = true;
      root.innerHTML = "";
      return;
    }

    root.hidden = false;
    root.innerHTML =
      '<div class="pdp-preorder">' +
      '<span class="pdp-preorder__dot" aria-hidden="true"></span>' +
      '<span class="pdp-preorder__text"><strong>Available for pre-order.</strong> Ships once it arrives - expected ' +
      escapeHtml(formatMonthYear(variant.restockDate)) +
      ".</span>" +
      "</div>";
  }

  function renderAddToCart() {
    var variant = getCurrentVariant();
    var label = getAddToCartLabel(variant);
    var labels = document.querySelectorAll(
      'product-form [name="add"] staged-action-text, product-form [name="add"] .js-product-add-text',
    );

    for (var i = 0; i < labels.length; i++) {
      labels[i].textContent = label;
    }
  }

  function renderConstruction() {
    var root = document.querySelector("[data-pdp-construction-root]");
    var state = readState();
    var variant = getCurrentVariant();
    var config = getConstructionConfig(variant, state);

    if (!root) return;

    if (!config) {
      root.hidden = true;
      root.innerHTML = "";
      return;
    }

    root.hidden = false;
    root.innerHTML =
      '<aside class="pdp-construction" aria-label="' +
      escapeHtml(config.label) +
      '">' +
      '<div class="pdp-construction__logo">' +
      '<img src="' +
      escapeHtml(config.src) +
      '" alt="' +
      escapeHtml(config.label) +
      '" loading="lazy" width="64" height="64">' +
      "</div>" +
      '<div class="pdp-construction__body">' +
      '<div class="pdp-construction__label">' +
      escapeHtml(config.label) +
      "</div>" +
      '<p class="pdp-construction__copy">' +
      escapeHtml(config.copy) +
      "</p>" +
      "</div>" +
      "</aside>";
  }

  function extractPromoHtml(html) {
    if (!html) return "";

    var container = document.createElement("div");
    container.innerHTML = html;

    var promo = container.querySelector(".comeswith-stuff");
    return promo ? promo.outerHTML : "";
  }

  function getPromoItems(html) {
    if (!html) return [];

    var container = document.createElement("div");
    container.innerHTML = html;

    var promo = container.querySelector(".comeswith-stuff");
    if (!promo) return [];

    var images = promo.querySelectorAll("img");
    var items = [];

    for (var i = 0; i < images.length; i++) {
      var alt = (images[i].getAttribute("alt") || "").toLowerCase();

      if (alt.indexOf("fins") !== -1 && items.indexOf("fins") === -1) {
        items.push("fins");
      } else if (
        alt.indexOf("leash") !== -1 &&
        items.indexOf("leash") === -1
      ) {
        items.push("leash");
      }
    }

    return items;
  }

  function renderPromoPillContent(items) {
    if (!items.length) return "";

    if (items.length === 2) {
      return (
        'Includes free <strong>Fins</strong> and a <strong>Leash</strong>'
      );
    }

    if (items[0] === "fins") {
      return 'Includes free <strong>Fins</strong>';
    }

    if (items[0] === "leash") {
      return 'Includes free <strong>Leash</strong>';
    }

    return "";
  }

  function extractDetailsHtml(html) {
    if (!html) return "";

    var container = document.createElement("div");
    container.innerHTML = html;

    var removableSelectors = [
      ".specs-container",
      ".dims-container",
      ".comeswith-stuff",
    ];
    for (var i = 0; i < removableSelectors.length; i++) {
      var nodes = container.querySelectorAll(removableSelectors[i]);
      for (var j = 0; j < nodes.length; j++) {
        nodes[j].remove();
      }
    }

    var headings = container.querySelectorAll(
      "h1, h2, h3, h4, h5, h6, strong, b",
    );
    for (var k = 0; k < headings.length; k++) {
      var headingText = (headings[k].textContent || "").trim().toLowerCase();
      if (
        headingText === "details" ||
        headingText === "specifications" ||
        headingText === "dimensions"
      ) {
        headings[k].remove();
      }
    }

    var wrappers = container.querySelectorAll("p, div");
    for (var l = 0; l < wrappers.length; l++) {
      var wrapperText = (wrappers[l].textContent || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
      if (
        wrapperText === "details" ||
        wrapperText === "specifications" ||
        wrapperText === "dimensions"
      ) {
        wrappers[l].remove();
      }
    }

    var normalized = container.innerHTML
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return normalized;
  }

  function renderFreebiesPromo() {
    var root = document.querySelector("[data-pdp-freebies-root]");
    var variant = getCurrentVariant();
    var promoHtml =
      variant && typeof variant.specificationsHtml === "string"
        ? extractPromoHtml(variant.specificationsHtml)
        : "";
    var items = getPromoItems(promoHtml);
    var text = renderPromoPillContent(items);

    if (!root) return;

    if (!text) {
      root.hidden = true;
      root.innerHTML = "";
      return;
    }

    root.hidden = false;
    root.innerHTML =
      '<div class="pdp-preorder pdp-preorder--freebies">' +
      '<span class="pdp-preorder__dot pdp-preorder__dot--freebies" aria-hidden="true"></span>' +
      '<span class="pdp-preorder__text">' +
      text +
      "</span>" +
      "</div>";
  }

  function renderDetails() {
    var root = document.querySelector("[data-pdp-details-root]");
    var variant = getCurrentVariant();
    var details = root && root.closest ? root.closest("details") : null;
    var html =
      variant && typeof variant.bulletsHtml === "string"
        ? extractDetailsHtml(variant.bulletsHtml)
        : "";

    if (!root) return;

    if (!html) {
      root.hidden = true;
      root.innerHTML = "";
      if (details) details.hidden = true;
      return;
    }

    if (details) details.hidden = false;
    root.hidden = false;
    root.innerHTML = html;
  }

  function renderTrust() {
    var root = document.querySelector("[data-pdp-trust-root]");
    var state = readState();
    var variant = getCurrentVariant();
    var items = getTrustMessages(state, variant);
    var html = "";

    if (!root || !items.length) return;

    for (var i = 0; i < items.length; i++) {
      html += renderTrustItem(items[i]);
    }

    root.innerHTML =
      '<div class="trust-messages pdp-trust-messages">' +
      '<ul class="trust-messages__list" role="list">' +
      html +
      "</ul>" +
      "</div>";
  }

  function renderSpecsDimensions() {
    var root = document.querySelector("[data-pdp-specs-root]");
    var variant = getCurrentVariant();
    var details = root && root.closest ? root.closest("details") : null;
    var html =
      variant && typeof variant.specificationsHtml === "string"
        ? variant.specificationsHtml.trim()
        : "";

    if (!root) return;

    if (!html) {
      root.hidden = true;
      root.innerHTML = "";
      if (details) details.hidden = true;
      return;
    }

    if (details) details.hidden = false;
    root.hidden = false;
    root.innerHTML = html;
  }

  function emitChange() {
    var detail = {
      product: readState(),
      variant: getCurrentVariant(),
    };

    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: detail }));
  }

  function renderAll() {
    renderAddToCart();
    renderPreorder();
    renderDetails();
    renderFreebiesPromo();
    renderConstruction();
    renderTrust();
    renderSpecsDimensions();
    scheduleSwatchSync();
    emitChange();
  }

  function scheduleRender() {
    setTimeout(renderAll, 0);
  }

  function init() {
    if (!document.body.classList.contains("template-product")) return;
    if (!readState()) return;

    renderAll();

    var swatchObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === "childList" || mutation.type === "attributes") {
          scheduleSwatchSync();
          return;
        }
      }
    });

    swatchObserver.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    document.addEventListener("change", function (event) {
      var target = event.target;
      if (!target) return;

      if (
        (target.name === "id" &&
          target.closest('product-form, form[action*="/cart/add"]')) ||
        (target.closest &&
          target.closest(
            'variant-radios, variant-selects, variant-mixed-inputs, product-form, form[action*="/cart/add"]',
          ))
      ) {
        scheduleRender();
      }
    });

    window.addEventListener("popstate", scheduleRender);
  }

  window.PdpProductState = {
    eventName: CHANGE_EVENT,
    getProduct: readState,
    getCurrentVariant: getCurrentVariant,
    subscribe: function (callback) {
      if (typeof callback !== "function") return function () {};

      var handler = function (event) {
        callback(event.detail);
      };

      document.addEventListener(CHANGE_EVENT, handler);
      return function () {
        document.removeEventListener(CHANGE_EVENT, handler);
      };
    },
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
